import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import { useNavigate } from "react-router";
import { URL } from "../../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import suitCase from "../../../Images/briefcase.svg";

function AnalyseCompanyFunds() {
  const navs = [
    {
        title: "Cashbook", 
        des: "View the inflow, outflow, terminated investments, maturing investments, and investible balance for each cashbook.",
        url: "Cashbook",
    },
    {
        title: "Recommend Amount", 
        des: "Recommend an amount from the cashbook to the H.O.D which will be used for investment.",
        url: "InvestmentRecommendations",
    },
    {
        title: "Setup Keywords", 
        des: "Setup Keywords within the system to facilitate the reconciliation of the cashbook and ledger.",
        url: "Keywords",
    },
  ]
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function NavCard({index, title, des, url}){

    return (
        <div key={index} className={` w-[220px] rounded-lg border border-solid border-[#DBD7D7] p-4 mr-10 flex flex-col items-start `}>
            <img src={suitCase} size={24} className={`mb-4`} alt="" />
            <h4 className={`font-[600] text-[16px] mb-4 text-[#1A1A1A]`}>{title}</h4>
            <div className="min-h-[100px]">
                <p className={`mb-4 text-[12px] text-[#1A1A1AB8]`}>{des}</p>
            </div>
            <div onClick={()=> navigate(url)} className={`w-[101px] flex justify-center text-[#305F32] rounded border-solid border border-[#305F32B8] py-1 active:scale-105 cursor-pointer `}>
                <p>Open</p>
            </div>
        </div>
    )
  }

  return (
    <RouteLayout title={"Finance"}>
      {/* <PageStyle
        title={"Analyse Company Funds"}
        hasBack={false}
        action={[]}
        isMain={true}
      > */}
        <h1 className="text-[#4B664C] text-[30px] font-[500] h-[38px] mb-10">Analyse Company Funds</h1>
        <main className="flex justify-start ">
        {
            navs.map((item, index) => <NavCard index={index} title={item.title} des={item.des} url={item.url} /> )
        }
        </main>
      {/* </PageStyle> */}
    </RouteLayout>
  );
}

export default AnalyseCompanyFunds;